<!-- Drag Handle -->
<div class="flex justify-center pt-3 pb-2">
  <div class="w-10 h-1 rounded-full bg-gray-300"></div>
</div>

<!-- Header -->
<div class="px-4 pb-3 border-b border-gray-100">
  <div class="flex items-center justify-between mb-3">
    <h3 class="text-base font-semibold text-gray-900">
      Edit Question {{ service.questionIndex }}
    </h3>
    <div class="flex items-center gap-2">
      <button
        class="sheet-cancel-btn"
        [disabled]="service.isSaving"
        (click)="service.cancel()"
      >
        Cancel
      </button>
      <button
        class="sheet-save-btn"
        [disabled]="service.isSaving || service.aiLoading"
        (click)="service.save()"
      >
        @if (service.isSaving) {
          <div class="sheet-save-spinner"></div>
          Saving...
        } @else {
          <lucide-icon [img]="icons.Save" class="w-3.5 h-3.5"></lucide-icon>
          Save
        }
      </button>
    </div>
  </div>
  <div class="sheet-tabs">
    <button
      class="sheet-tab"
      [class.sheet-tab-active]="activeTab === 'edit'"
      (click)="switchTab('edit')"
    >
      <lucide-icon [img]="icons.Pencil" class="w-3.5 h-3.5"></lucide-icon>
      Question
    </button>
    <button
      class="sheet-tab"
      [class.sheet-tab-active]="activeTab === 'rubric'"
      (click)="switchTab('rubric')"
    >
      <lucide-icon
        [img]="icons.ClipboardList"
        class="w-3.5 h-3.5"
      ></lucide-icon>
      Rubric
    </button>
  </div>
</div>

<!-- Scrollable Tab Content -->
<div class="sheet-tab-content">
  @if (activeTab === 'edit') {
    <app-question-edit-content />
  }

  @if (activeTab === 'rubric') {
    <app-rubric-content />
  }
</div>

<!-- Footer -->
<div class="sheet-footer">
  <!-- AI Panel (only on Question tab) -->
  @if (activeTab === 'edit') {
    <div class="ai-panel">
      <div class="ai-chips-row">
        @for (action of service.quickActions; track action.label) {
          <button
            class="ai-chip"
            [disabled]="service.aiLoading || service.isSaving"
            (click)="service.applyQuickAction(action.label)"
          >
            <lucide-icon [img]="action.icon" class="w-3 h-3"></lucide-icon>
            {{ action.label }}
          </button>
        }
      </div>
      <div class="ai-input-row">
        <textarea
          rows="1"
          [(ngModel)]="service.aiInstruction"
          placeholder="Edit with AI..."
          class="ai-inline-input"
          [disabled]="service.aiLoading || service.isSaving"
        ></textarea>
        <button
          class="ai-send-btn"
          [disabled]="
            !service.aiInstruction.trim() ||
            service.aiLoading ||
            service.isSaving
          "
          (click)="service.submitAiInstruction()"
        >
          @if (service.aiLoading) {
            <div class="ai-loading-spinner"></div>
          } @else {
            <lucide-icon
              [img]="icons.Send"
              class="w-3.5 h-3.5"
            ></lucide-icon>
          }
        </button>
      </div>
    </div>
  }
</div>
